import React from "react";
import { useClasses, Form, TextInput, Button, Checkbox, Row, Col, Typo, } from "../../";
import Seperator from "../Seperator";
import StateHandler from "../StateHandler";
import { register, } from "../../hooks/useAuthenticator";
import useI18n from "../../hooks/useI18n";
const styes = (theme) => ({
    section: {
        margin: "0px 0px",
        color: theme.palette.get("primary"),
        textTransform: "uppercase",
        fontWeight: 600,
        fontSize: "1rem",
        letterSpacing: "0.01rem",
    },
});
export default function Register(props) {
    const classes = useClasses(styes);
    const { state, values, errors } = props.state;
    const setState = props.setState;
    const onChangeString = (field) => {
        return (value) => setState({
            ...props.state,
            values: { ...values, [field]: value || "" },
        });
    };
    const onChangeBool = (field) => {
        return (value) => setState({
            ...props.state,
            values: { ...values, [field]: value || "" },
        });
    };
    const i18n = useI18n(props.translationGroup);
    const i18nErrors = useI18n("errors");
    return (React.createElement(React.Fragment, null,
        React.createElement(Typo, { variant: "h2", margin: "none" }, i18n.get("signUp")),
        React.createElement(StateHandler, { state: state, onErrorReset: () => setState({ ...props.state, state: "ok" }) },
            React.createElement(Form, { spacing: 8, vertical: true, root: { left: 0, right: 0, top: 16, bottom: 0 }, onSubmit: (e) => e.preventDefault() },
                React.createElement(TextInput, { inline: true, autoComplete: "given-name", label: i18n.get("firstname"), value: values.firstname, onChange: onChangeString("firstname"), error: errors.firstname && i18nErrors.get(errors.firstname || "") }),
                React.createElement(TextInput, { inline: true, autoComplete: "family-name", label: i18n.get("lastname"), value: values.lastname, onChange: onChangeString("lastname"), error: errors.lastname && i18nErrors.get(errors.lastname) }),
                React.createElement(TextInput, { inline: true, autoComplete: "username", label: i18n.get("email/username"), name: "new-username", value: values.email, onChange: onChangeString("email"), error: errors.email && i18nErrors.get(errors.email) }),
                React.createElement(TextInput, { inline: true, autoComplete: "on", label: i18n.get("password"), name: "new-passwored", password: true, value: values.password, onChange: onChangeString("password"), error: errors.password && i18nErrors.get(errors.password) }),
                React.createElement(Checkbox, { inline: true, label: i18n.get("agbs"), value: values.agbs, onChange: onChangeBool("agbs"), error: errors.agbs && i18nErrors.get(errors.agbs) }),
                React.createElement(Checkbox, { inline: true, label: i18n.get("dsgvo"), value: values.dsgvo, onChange: onChangeBool("dsgvo"), error: errors.dsgvo && i18nErrors.get(errors.dsgvo) }),
                React.createElement(Row, { spacing: 8, root: { left: 0, right: 0, top: 8, bottom: 16 }, horizontalAlign: "right" },
                    React.createElement(Button, { xs: "120px", onClick: async () => {
                            const success = await register(props.state, setState);
                            if (success)
                                setTimeout(() => props.onModeChange("challengeEmail"), 1000);
                        }, success: true }, i18n.get("signUp")))),
            React.createElement(Seperator, null),
            React.createElement(Row, { root: { top: 16 } },
                React.createElement(Col, null,
                    React.createElement(Button, { link: true, onClick: () => props.onModeChange("login") }, i18n.get("You_already_have_an_Account?")))))));
}
